module.exports = __webpack_public_path__ + "static/media/car3.8853ed0b.gif";